export default __webpack_public_path__ + "static/media/fitnessfinder.e86c6d10.jpg";